import React from "react";
import Helper from '../functions/Helper.js';

export default function SliderItem(props){
  let swiperWidth=props.swiperWidth;
  let style=props.styleItem;
  let imageHeight= props.imageHeight ? props.imageHeight : 0.85*swiperWidth;
  let colorwaysExist=false;

  if(!props.preview){
    if(style.colorways.length>0){
      colorwaysExist=true;
      var firstColorway=style.colorways[0];
      var discount=Math.round((1-(firstColorway.price_discount/firstColorway.list_price))*100);
    }
  }

  return(
    <div style={{cursor:"pointer",width:swiperWidth}} onClick={props.onClick}>
      <div style={{backgroundColor:"#f8f8f8",height:imageHeight,}} >
        {!props.preview &&
          <picture>
            <source
              type="image/webp"
              data-srcset={Helper.create_source_set({master:style.picture_url,thumbnails:"1"},undefined,"webp")}
              sizes={swiperWidth+"px"}
              />
            <source
              type="image/png"
              data-srcset={Helper.create_source_set({master:style.picture_url,thumbnails:"1"})}
              sizes={swiperWidth+"px"}
              />
            <img
              width={style.width}
              height={style.height}
              style={{padding:"10px",width:swiperWidth,height:imageHeight,objectFit:"contain",objectPosition:"bottom",transform:style.mirror==="1" && "scaleX(-1)",...props.imageProps}}
              alt={style.name}
              sizes={swiperWidth+"px"}
              data-expand={200}
              className="lazyload"
              data-src={Helper.add_options_img(style.picture_url,143)}/>
          </picture>
        }
      </div>

      <div style={{paddingHorizontal:10,flex:1,padding:5,...props.textContainerStyle}}>
        {!props.preview &&
          <React.Fragment>
            {props.showShoeName &&
              <div style={{
                  fontSize:14,
                  lineHeight:1.3,
                  fontWeight:700,
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  display: "-webkit-box",
                  "WebkitBoxOrient":"vertical",
                  "WebkitLineClamp": props.showShoeName ? "2" : "1",
                  marginTop:3}}>
                {props.shoeName}
              </div>
            }
            {props.showStyleName &&
              <div style={{
                  fontSize:14,
                  lineHeight:1.3,
                  fontWeight:props.showShoeName ? "400" : "600",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  display: "-webkit-box",
                  "WebkitBoxOrient":"vertical",
                  "WebkitLineClamp": props.showShoeName ? "1" : "2",
                  marginTop:3}}>
                  {style.name}
              </div>
            }

            {colorwaysExist ?
              <React.Fragment>
                <div style={{  fontSize:14,lineHeight:1.3,marginTop:3,color:"#767676"}}>
                  {style.colorways.length>1 ? "in " + style.colorways.length + " shops" : "from " + firstColorway.shop_name}
                </div>
                <div style={{marginTop:2,lineHeight:1.3,display:"flex",flexDirection:"row"}}>
                  <div style={{color:discount>1 ? "#e32b2b" :"black",fontWeight:discount>1 ? 500 : 400}}>
                    ${firstColorway.price_discount}
                  </div>
                  {discount> 1 &&
                  <div style={{color:"#767676",textDecorationLine:"line-through",display:"flex",justifyContent:"center",alignItems:"center",textDecorationStyle: 'solid',marginLeft:5,fontSize:14}}>
                    ${Math.round(Number(firstColorway.list_price))}
                  </div>}
                </div>
              </React.Fragment>
              :
              <React.Fragment>
                <div style={{marginTop:2}}>
                  <div style={{fontSize:14,color:"#767676"}}>No stores found</div>
                </div>
              </React.Fragment>
              }
            </React.Fragment>
          }
      </div>
    </div>
  )
}

SliderItem.defaultProps={
  showStyleName:true,
  showLikeButton:true
}
